module.exports = __webpack_public_path__ + "img/bandera-canada.f043987d.png";